import React from 'react'


const GestProcessos = () => {
  return (
    <div>
      <h1 style={{marginLeft: 300, fontFamily: "Avenir Next"}}>Gest Admin - Processos</h1>
    </div>
  )
}

export default GestProcessos